export let windowTitleFormatString = "YnYIUb";
export default {windowTitleFormatString};